import dynamic from "next/dynamic";

import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export const LazyBrandApplication = dynamic(
  () =>
    import(
      /* webpackChunkName: "brand-application" */
      "@faire/retailer/views/apply/MakerApplication/index"
    )
      .then((m) => ({ default: m.BrandApplication }))
      .catch(handleComponentLoadError),
  {
    ssr: false,
  }
);
